import { DateTime, Interval } from 'luxon';

export const scrollCalendar = (direction, container) => {
  if (container.current) {
    const currentPosition = container?.current?.scrollLeft;
    const currentScrollWidth = 74;

    container?.current?.scrollTo({
      left:
        direction === 'back'
          ? currentPosition - currentScrollWidth
          : currentPosition + currentScrollWidth,
      top: 0,
      behavior: 'smooth',
    });
  }
};

export const createCalendarCarousel = selectedDays => {
  const sortedSelectedDays = [...selectedDays].sort();
  const fromMillis = DateTime.fromMillis;

  const start = fromMillis(sortedSelectedDays[0]);

  const end = fromMillis(sortedSelectedDays[sortedSelectedDays?.length - 1]);

  const plusMinusDays =
    19 - sortedSelectedDays.length < 0
      ? 3
      : (19 - sortedSelectedDays.length) / 2;

  const getExtendedDatesRange = direction => {
    let array = [];
    for (let i = 0; i < plusMinusDays; i++) {
      if (direction === 'plus') {
        array.push(end.plus({ days: i + 1 }));
      } else {
        array.push(start.minus({ days: i + 1 }));
      }
    }
    return array;
  };
  const interval = Interval.fromDateTimes(start, end);

  function* days(item) {
    let cursor = item.start.startOf('day');
    while (cursor <= item.end) {
      yield cursor;
      cursor = cursor.plus({ days: 1 });
    }
  }

  const intervalSelectedDays = Array.from(days(interval));

  return getExtendedDatesRange('minus')
    .reverse()
    .concat(intervalSelectedDays.concat(getExtendedDatesRange('plus')));
};

export const maxMenuSelectionDaysAhead = (formSettings, day) =>
  !!formSettings?.orderSettings.menuSelectionDaysAhead &&
  formSettings.orderSettings.menuSelectionDaysAhead > 0 &&
  DateTime.local()
    .plus({
      days: formSettings?.orderSettings.menuSelectionDaysAhead,
    })
    .toISODate() <= day;
